import { TabHeader } from "@pages/HomePage/TabHeader"
import * as Tabs from "@radix-ui/react-tabs"
import { useAppSelector } from "@redux/app/hooks"
import { getAppState } from "@redux/app/store"
import { requestApi2_getError } from "@utils/http"
import { ConfigurationModule, TableDbEditingWidget, endpoints } from "api"
import { useEffect, useState } from "react"
import Button from "./Button"
import { DbConfigEditingWidget } from "./DbConfigEditingWidget"

type UserWidgetTab = "users" | "roles" | "companies"

const userWidgetTabs: {
	key: UserWidgetTab
	label: string
	widgetLabels: string[]
}[] = [
	{ key: "users", label: "Users", widgetLabels: ["New user", "Users"] },
	{ key: "roles", label: "Roles", widgetLabels: ["New role", "Roles"] },
	{ key: "companies", label: "Companies", widgetLabels: ["New company", "Companies"] },
]

export default function DataEditPage(args: { module: ConfigurationModule; _key?: string }) {
	const [widgets, setWidgets] = useState<TableDbEditingWidget[] | undefined>()
	const [activeUserTab, setActiveUserTab] = useState<string>("0")
	const appStateSelector = useAppSelector(getAppState)
	const [busy, setBusy] = useState(false)
	async function refresh() {
		if (busy) return
		setBusy(true)
		setWidgets(undefined)
		try {
			const widgets = await requestApi2_getError(endpoints.dbConfigGetWidgets, {
				module: args.module,
				key: args._key,
			})
			if (widgets === null) {
				return
			}
			setWidgets(widgets)
		} catch (err) {
			console.error(err)
		}
		setBusy(false)
	}

	useEffect(() => {
		refresh()
	}, [args._key])

	useEffect(() => {
		if (appStateSelector.isConnected) {
			// refresh()
		}
	}, [appStateSelector.isConnected])

	useEffect(() => {
		setActiveUserTab("0")
	}, [args.module, args._key])

	function renderWidgets(widgetsToRender: TableDbEditingWidget[]) {
		return widgetsToRender.map((widget, i) => (
			<DbConfigEditingWidget
				key={`${widget.label}-${i}`}
				widget={widget}
				doSubmit={async (objects) => {
					await requestApi2_getError(endpoints.configurateDb, {
						module: args.module,
						objects: objects,
						table: widget.label,
						key: args._key,
					})
				}}
				doCreate={async () => {
					await requestApi2_getError(endpoints.dbConfigCreateObject, {
						module: args.module,
						table: widget.label,
						key: args._key,
					})
				}}
			/>
		))
	}

	return (
		<>
			<Button
				label="Refresh"
				onClick={refresh}
				disabled={widgets == undefined}
			/>
			{widgets == undefined ? (
				<p>Loading...</p>
			) : args.module === ConfigurationModule.User ? (
				<Tabs.Root
					value={activeUserTab}
					onValueChange={setActiveUserTab}
				>
					<Tabs.List className="mt-2 flex flex-wrap gap-1 overflow-auto">
						{userWidgetTabs.map((tab, index) => (
							<TabHeader
								key={tab.key}
								activeTab={activeUserTab}
								tabIndex={index}
								tabName={tab.label}
							/>
						))}
					</Tabs.List>
					{userWidgetTabs.map((tab, index) => (
						<Tabs.Content
							key={tab.key}
							value={index.toString()}
							forceMount
							className={activeUserTab === index.toString() ? "block" : "hidden"}
						>
							{renderWidgets(
								tab.widgetLabels
									.map((label) =>
										widgets.find((widget) => widget.label === label)
									)
									.filter(
										(widget): widget is TableDbEditingWidget =>
											widget != undefined
									)
							)}
						</Tabs.Content>
					))}
				</Tabs.Root>
			) : (
				renderWidgets(widgets)
			)}
		</>
	)
}
